export default __webpack_public_path__ + "static/media/ill-no-data.a2bab0a1.svg";